import { apiClient } from "helpers/api_helper";
import notistack from "modules/core/notistack";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ConfirmActionModal = ({ show, onHide, data, isEcomLocked }: { show: boolean; onHide: () => void; data: any, isEcomLocked?: boolean }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const handleYes = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`api/v1/InterStoreTransfer/CancelInterstoreOrder?id=${data}`);
            if (response.status === 200) {
                notistack.notifyFromApi(response);
                onHide();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (err: any) {
            toast.error(err.response?.data?.message || err.message || "Yes action failed");
        } finally {
            setLoading(false);
        }
    };

    const handleNo = async () => {
        onHide()
    };

    const handleEcomYes = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`api/v1/ProductDetails/UnlockEcomProductHeader?id=${data}`);
            if (response.status === 200) {
                notistack.notifyFromApi(response);
                onHide();
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (err: any) {
            toast.error(err.response?.data?.message || err.message || "Yes action failed");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal show={show} onHide={onHide} centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Action</Modal.Title>
            </Modal.Header>
            <Modal.Body>{isEcomLocked ? 'This product is already linked to an eCommerce order. Would you like to proceed with selling it anyway?' : 'This product is currently locked by another store. Do you still want to proceed with selling it?'}</Modal.Body>
            <Modal.Footer>
                <Button className="btn add-btn" onClick={handleNo} disabled={loading}>
                    No
                </Button>
                <Button className="btn submit-btn" onClick={isEcomLocked ? handleEcomYes : handleYes} disabled={loading}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmActionModal;
